/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserOnboardingPayloadDto
 */
export interface UserOnboardingPayloadDto {
    /**
     * 
     * @type {string}
     * @memberof UserOnboardingPayloadDto
     */
    accessToken: string;
}

/**
 * Check if a given object implements the UserOnboardingPayloadDto interface.
 */
export function instanceOfUserOnboardingPayloadDto(value: object): value is UserOnboardingPayloadDto {
    if (!('accessToken' in value) || value['accessToken'] === undefined) return false;
    return true;
}

export function UserOnboardingPayloadDtoFromJSON(json: any): UserOnboardingPayloadDto {
    return UserOnboardingPayloadDtoFromJSONTyped(json, false);
}

export function UserOnboardingPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserOnboardingPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'accessToken': json['accessToken'],
    };
}

export function UserOnboardingPayloadDtoToJSON(json: any): UserOnboardingPayloadDto {
    return UserOnboardingPayloadDtoToJSONTyped(json, false);
}

export function UserOnboardingPayloadDtoToJSONTyped(value?: UserOnboardingPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accessToken': value['accessToken'],
    };
}

